import { formatDateInput } from '../../utils/inputValidation';

const FianceCard = ({ data = {}, setData, prefix = "" }) => {
  const handleChange = (field) => (e) => {
    const value = e.target.value;

    // Verificar que setData sea una función válida
    if (typeof setData !== 'function') {
      console.error('[FianceCard] setData no es una función válida');
      return;
    }

    setData({
      ...data,
      [`${prefix}${field}`]: value,
    });
  };

  return (
  <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden group">

    {/* Barra superior igual que Titular */}
    <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>

    {/* Header */}
    <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">
      <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">
       <span className="material-icons text-honda-600">people</span>
        DATOS DEL CÓNYUGE
      </h3>
    </div>

    {/* Body */}
    <div className="p-4">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">

        {/* Nombre */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Nombre Completo <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data[`${prefix}CompleteName`] ?? ""}
            onChange={handleChange("CompleteName")}
            className="w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500"
          />
        </div>

        {/* Documento */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Número de Documento <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data[`${prefix}DocumentNumber`] ?? ""}
            onChange={handleChange("DocumentNumber")}
            className="w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500"
          />
        </div>

        {/* Fecha */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Fecha de Nacimiento <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data[`${prefix}BirthDate`] ?? ""}
            onChange={(e) => {
              const formatted = formatDateInput(e.target.value);
              if (typeof setData !== 'function') return;
              setData({ ...data, [`${prefix}BirthDate`]: formatted });
            }}
            placeholder="dd/mm/aaaa"
            maxLength="10"
            className="w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500"
          />
        </div>

        {/* Sexo */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Sexo <span className="text-red-500">*</span>
          </label>
          <select
            value={data[`${prefix}Gender`] ?? ""}
            onChange={handleChange("Gender")}
            className="w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500"
          >
            <option value="">Seleccione...</option>
            <option value="1 - Masculino">1 - Masculino</option>
            <option value="2 - Femenino">2 - Femenino</option>
          </select>
        </div>

        {/* Nacionalidad */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            Nacionalidad <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data[`${prefix}Nationality`] ?? ""}
            onChange={handleChange("Nationality")}
            className="w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500"
          />
        </div>

        {/* PEP */}
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">
            PEP <span className="text-red-500">*</span>
          </label>
          <select
            value={data[`${prefix}PEP`] ?? ""}
            onChange={handleChange("PEP")}
            className="w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500"
          >
            <option value="">Seleccione...</option>
            <option value="SI">Sí</option>
            <option value="NO">No</option>
          </select>
        </div>

      </div>
    </div>
  </div>
);
};

export default FianceCard;